<template>

    <modal :show="showModal" @closeModal="close">

        <div class="flex-collumn padding-modal">

            <img class="med-img" src="/img/foxy/connect-wild.svg">

            <h1 class="cf-headline med-title">{{ $tc('invalid_grant_title', 0, {mailbox: email}) }}</h1>

            <p class="cf-caption-1 med-text">{{ $t('invalid_grant_description') }}</p>

            <button class="btn btn-blue btn-big med-btn-first" @click="reconnect">{{ $t('invalid_grant_cta_reconnect') }}</button>

            <button class="btn btn-grey btn-big" @click="close">{{ $t('settings_cta_cancel_delete') }}</button>

        </div>

    </modal>

</template>

<script>

import Markdown from '@/components/Markdown'
import Modal from '@/components/modal/Modal'

export default {

    name: 'modal-email-deconnected',

    components: { Markdown, Modal },

    data () {
        return {
            showModal: false,
            email: ''
        }
    },

    methods: {

        open (email) {
            this.email = email
            this.showModal = true
        },

        close () {
            this.showModal = false
        },

        reconnect () {
            this.$router.push({
                name: 'add-inbox',
                params: {
                    email: this.email
                }
            })
        },

        next () {
            this.close()
        }

    }

}

</script>

<style scoped lang="scss">

    .padding-modal {
        padding: 24px 16px;
    }

    .med-img {
        width: 72px;
        object-fit: contain;
        margin-bottom: 16px;
    }

    .med-title {
        margin: 16px 0 8px;
    }

    .med-text {
        color: $grey;
    }

    .med-btn-first {
        margin: 24px 0 8px;
    }


</style>
